import request from './request';

export function addWatchHistory(videoId, watchDuration) {
  return request.post('/api/watch_history/add', { video_id: videoId, watch_duration: watchDuration });
}
export function getWatchHistoryList(params) {
  return request.get('/api/watch_history/myList', { params });
}
export function clearWatchHistory() {
  return request.post('/api/watch_history/clear');
}
